import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { InputControl } from "../../../shared";
import SimpleReactValidator from "simple-react-validator";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const StoreUpdateDialog = (props) => {
  const {
    onSubmit,
    templates,
    onChangeStoreEffectiveDate,
    setTemplates,
    handleClose,
    state,
    isDisabled,
  } = props;

  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const { alert_radio, effective_date } = templates;

  const onSubmitData = () => {
    if (validator.current.allValid()) {
      onSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDate = tomorrow.toISOString().split("T")[0];

  const handleRadioChange = (event) => {
    const value = event.target.value;
    let selectedDate;
    if (value === "1") {
      selectedDate = today;
    } else if (value === "2") {
      selectedDate = tomorrowDate;
    }
    setTemplates((draft) => {
      draft.alert_radio = value;
      draft.effective_date = selectedDate;
    });
  };

  return (
    <>
      <Stack sx={{ padding: "12px 20px 12px 20px" }}>
        <FormControl>
          <RadioGroup
            sx={{ gap: "8px" }}
            value={alert_radio}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              control={<Radio />}
              label="Update From Today"
              value="1"
            />
            <FormControlLabel
              control={<Radio />}
              label="Update From Tomorrow"
              value="2"
            />
            <FormControlLabel
              control={<Radio />}
              label="Update From :"
              value="3"
            />
          </RadioGroup>
        </FormControl>
        {alert_radio === "3" && (
          <>
            <InputControl
              sx={{ width: "250px", pt: "8px" }}
              name="effective_date"
              value={effective_date}
              type="datePicker"
              disablePast
              sie="small"
              inputFormat="dd/MM/yyyy"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              size="small"
              onChange={(dateValue) => onChangeStoreEffectiveDate(dateValue)}
            />

            <FormHelperText sx={{ fontWeight: 500 }}>
              {templates?.data?.end_date &&
                `Ending on ${templates?.data?.end_date}`}
            </FormHelperText>
          </>
        )}
        <FormHelperText sx={{ color: "error.main" }}>
          {validator.current.message(
            "Effective Date",
            effective_date,
            "required"
          )}
        </FormHelperText>
      </Stack>
      <CustomDialogFooter
        handleClose={handleClose}
        disabled={state?.isLoading || isDisabled || !alert_radio}
        onSubmit={onSubmitData}
        onClick={handleClose}
      />
    </>
  );
};
